import { get, post } from "./index";
export enum Status {
  Completed = "completed",
  Pending = "pending",
  Timeout = "timeout",
}

export enum OrderType {
  Normal = "normal",
  DirectPay = "directPay",
  Withdraw = "withdraw",
}

export interface Order {
  orderAmount: string;
  spendAmount: string;
  taxAmount: string;
  taxRate: string;
  tipAmount: string;
  id: number;
  status: Status;
  hash: string;
  orderType?: string;
  createdAt: string;
  updatedAt: string;
  recipientAmount: string;
  spentCurrency: string;
  spentAmount: string;
  feeAmount: string;
  recipient: {
    didName: string;
    address: string;
    avatar: string;
  };
  sender: {
    address: string;
    avatar: string;
  };
}

export const createOrder = async (data: {
  amount: string;
  recipient: `0x${string}`;
}) => {
  const response = await post<Order>("/orders", data);
  return response;
};

export const createOrderForMerchant = async ({
  recipient,
  orderAmount,
}: {
  recipient: `0x${string}`;
  orderAmount: string;
}) => {
  const response = await post<Order>(`/orders/merchant/${recipient}`, {
    orderAmount,
    taxRate: "0",
  });
  return response;
};

export const getOrder = async (orderId: string) => {
  const response = await get<Order>(`/orders/${orderId}`);
  return response;
};

export const getRecipientOrders = async ({
  recipient,
}: {
  recipient: `0x${string}`;
}) => {
  const response = await get<Order[]>(`/orders?recipient=${recipient} `);
  return response;
};

export const getSenderOrders = async ({
  sender,
}: {
  sender: `0x${string}`;
}) => {
  const response = await get<Order[]>(`/orders/sender/${sender}`);
  return response;
};
